import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { ExportDetailsModel } from '../../models/ExportDetailsModel';
import { AuditLogService } from '../../services/audit/audit-log.service';
import { ExportFileService } from '../../services/exportFile/export-file.service';
import { UserService } from '../../services/user/user.service';
import { BaseApiService } from '../../services/base-api.service';
import { Logging } from '../../utils/logging';

@Component({
  selector: 'app-file-download',
  templateUrl: './file-download.component.html',
  styleUrls: ['./file-download.component.scss'],
  standalone: false,
})
export class FileDownloadComponent implements OnInit {
  downloadCccUrl = '/api/Download/DownloadCccExportFile';
  downloadSearchUrl = '/api/Download/DownloadExportFile';

  displayedColumns = [
    'id',
    'fileName',
    'recordCount',
    'requestDate',
    'processDate',
    'processStatus',
    'requestedUser',
    'downloadFile',
    'parameters',
  ];

  userName: string = '';
  email: string = '';
  internalUser: boolean = false;

  loadError = false;
  loading: boolean;
  currentFilter;
  dataSource: MatTableDataSource<ExportDetailsModel>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input() exportType: string; //"Search","CCC",etc

  constructor(
    private user: UserService,
    private baseApiService: BaseApiService,
    private exportFile: ExportFileService,
    private auditService: AuditLogService,
  ) {
    user.emailAddress.subscribe(value => {
      this.email = value;
    });
    user.userName.subscribe(value => {
      this.userName = value;
    });
    user.isInternal.subscribe(v => {
      this.internalUser = v;
    });
  }

  ngOnInit() {
    this.loadError = false;
    this.currentFilter = '';
    this.dataSource = new MatTableDataSource();
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.filterPredicate = (
      data: ExportDetailsModel,
      filter: string,
    ) => {
      if (!filter || filter == '') return true;
      // Create string with all of the data from shown columns for the row.
      // Seperated by a non-typable character (in this case a bullet)
      let sString = '';
      try {
        let exportDownloadData = Object.keys(this.dataSource.data[0]);
        exportDownloadData.forEach(key => {
          sString = sString.concat(data[key], String.fromCharCode(149));
        });
      } catch (e) {
        Logging.error('Error in filter');
      }
      // Look for the filter in the concatinated data
      return sString.toLowerCase().includes(filter.toLowerCase());
    };
    this.getData();
  }

  getData() {
    this.loading = true;

    this.exportFile
      .getExportDetails(this.exportType)
      .then(data => {
        this.loading = false;
        if (data == null) {
          this.loadError = true;
        } else {
          this.dataSource.data = data;
        }
      })
      .catch(error => {
        this.loadError = true;
        this.loading = false;
        Logging.error(error);
      });
  }

  public ExternalRefresh(): void {
    setTimeout(() => {
      this.getData();
    }, 5000);
  }

  applyFilter(filterValue: string) {
    this.currentFilter = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  downloadExportFile(exportFileName: string) {
    let apiUrl = '';
    switch (this.exportType) {
      case 'Search': {
        apiUrl = this.downloadSearchUrl;
        break;
      }
      case 'CCC': {
        apiUrl = this.downloadCccUrl;
        break;
      }
    }

    const fileLoc =
      apiUrl + '?EmailAddress=' + this.email + '&FileName=' + exportFileName;

    const memberSafe = exportFileName.toLowerCase().indexOf('membersafe') > 0;
    const reportType = this.internalUser
      ? memberSafe
        ? 'External Member Safe'
        : 'Internal'
      : 'Member Safe';
    this.auditService.downloadEvent(reportType);

    this.baseApiService.userToken = this.user.token.value;
    this.baseApiService.downloadFile(fileLoc);
  }
}
